import { StationPlugType } from './station-plug-type.model';

export class PlugTypeItem {
  constructor(plugType: StationPlugType, plugTypeText: string) {
    this.PlugType = plugType;
    this.PlugTypeText = plugTypeText;
  }

  PlugType: StationPlugType;
  PlugTypeText: string;
}
